// Cache utility for profile data using localStorage
const CACHE_PREFIX = 'profile_cache_';
const CACHE_EXPIRY = 5 * 60 * 1000; // 5 minutes in milliseconds

export const profileCache = {
    // Set cache with timestamp
    set: (key, data) => {
        try {
            const cacheData = {
                data,
                timestamp: Date.now(),
            };
            localStorage.setItem(`${CACHE_PREFIX}${key}`, JSON.stringify(cacheData));
        } catch (error) {
            console.error('Error setting cache:', error);
        }
    },

    // Get cache if not expired
    get: (key) => {
        try {
            const cached = localStorage.getItem(`${CACHE_PREFIX}${key}`);
            if (!cached) return null;

            const { data, timestamp } = JSON.parse(cached);
            const now = Date.now();

            // Check if cache is expired
            if (now - timestamp > CACHE_EXPIRY) {
                profileCache.remove(key);
                return null;
            }

            return data;
        } catch (error) {
            console.error('Error getting cache:', error);
            return null;
        }
    },

    // Remove specific cache
    remove: (key) => {
        try {
            localStorage.removeItem(`${CACHE_PREFIX}${key}`);
        } catch (error) {
            console.error('Error removing cache:', error);
        }
    },

    // Clear all profile caches
    clearAll: () => {
        try {
            Object.keys(localStorage).forEach(key => {
                if (key.startsWith(CACHE_PREFIX)) {
                    localStorage.removeItem(key);
                }
            });
        } catch (error) {
            console.error('Error clearing cache:', error);
        }
    },

    // Invalidate cache when data is edited
    invalidate: (userId) => {
        profileCache.remove(`user_${userId}`);
        profileCache.remove(`experience_${userId}`);
        profileCache.remove(`education_${userId}`);
        profileCache.remove(`projects_${userId}`);
        profileCache.remove(`resumes_${userId}`);
        profileCache.remove(`rankings_${userId}`);
    }
};
